// @ts-nocheck

import { EllipsisOutlined } from '@ant-design/icons';
import Button from 'antd/lib/button';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import Menu from 'antd/lib/menu';

import notification from 'antd/lib/notification';
import moment from 'moment';
import React from 'react';
import styled from 'styled-components';
import { DatePicker } from '../../../components/ant/DatePicker';
import { InputNumber } from '../../../components/inputs';
import { notificationLoading } from '../../../components/Notifications';
import { Dropdown, ListTable } from '../../../components/ui';

import { Selects } from './../../../components';

import { incomeScheduleApi } from './../../../lib/api';
import { measureType, nomenclatureType } from './../../../lib/enum';
import { formatDate, isEmptyValue as isEmpty, withEmptyRow, withoutEmptyRow } from './../../../lib/helpers';


const { NomenclatureTypeSelect, MeasureTypeSelect } = Selects;
const FormItem = Form.Item;












const StyledFormItem = styled(FormItem).withConfig({ displayName: "IncomeSchedule__StyledFormItem", componentId: "sc-1uoenbi-0" })(["margin-bottom:0px;"]);


const Operations = styled.div.withConfig({ displayName: "IncomeSchedule__Operations", componentId: "sc-1uoenbi-1" })(["display:flex;align-items:center;justify-content:center;height:100%;"]);





const Footer = styled.div.withConfig({ displayName: "IncomeSchedule__Footer", componentId: "sc-1uoenbi-2" })(["margin-top:10px;.ant-btn{margin-right:10px;}"]);






export default class extends React.Component {
  state = {
    touched: false,
    handleSubmitting: false,
    incomeSchedules: this.props.incomeSchedules,
    deleteIncomeSchedules: []
  };

  componentDidUpdate(prevProps) {
    const { incomeSchedules } = this.props;
    if (this.props.stageId !== prevProps.stageId) {
      this.setState({ incomeSchedules });
    }
  }

  async onChange(index, key, value) {
    let incomeSchedules = withEmptyRow([...this.state.incomeSchedules]);
    if (this.state.touched === false) {
      this.setState({ touched: true });
    }
    incomeSchedules.splice(index, 1, {
      ...incomeSchedules[index],
      [key]: value
    });
    await this.setState({ incomeSchedules });
  }

  onDelete(index) {
    const { incomeSchedules, deleteIncomeSchedules } = this.state;
    if (this.state.touched === false) {
      this.setState({ touched: true });
    }
    this.setState({
      incomeSchedules: incomeSchedules.filter((value, id) => id !== index),
      deleteIncomeSchedules: [...deleteIncomeSchedules, incomeSchedules[index]]
    });
  }

  saveUpdateIncomeSchedule = async (incomeSchedule) => {
    try {
      if (incomeSchedule.id) {
        return await incomeScheduleApi.updateIncomeSchedule(incomeSchedule);
      } else {
        return await incomeScheduleApi.addIncomeSchedule(incomeSchedule);
      }
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
      return undefined;
    }
  };

  deleteIncomeSchedules = async () => {
    const { deleteIncomeSchedules } = this.state;
    const results = await Promise.allSettled(
      deleteIncomeSchedules.map((incomeSchedule) =>
        incomeSchedule.id ?
        incomeScheduleApi.deleteIncomeSchedule(incomeSchedule.id) :
        Promise.resolve()
      )
    );
    const failedIncomeSchedules = deleteIncomeSchedules.filter(
      (_, index) => results[index].status === 'rejected'
    );

    this.setState({ deleteIncomeSchedules: failedIncomeSchedules });
    if (failedIncomeSchedules.length > 0) {
      notification.error({
        message: 'Ошибка',
        description: 'Не удалось удалить все графики'
      });
      return true;
    }
    return false;
  };

  // проверим заполнены ли все обязательные поля
  validate = (incomeSchedules) => {
    incomeSchedules.forEach((incomeSchedule, index) => {
      [
      'schedulePoint',
      'startDate',
      'endDate',
      'sum',
      'sumWithTax',
      'nomenclatureName',
      'count',
      'measureType'].
      forEach((key) => {
        if (isEmpty(incomeSchedule[key])) {
          throw new Error('Заполните все поля в графиках');
        }
      });
    });
  };

  handleCancel = () => {
    this.setState({
      incomeSchedules: this.props.incomeSchedules,
      touched: false,
      handleSubmitting: false,
      deleteIncomeSchedules: []
    });
  };

  handleSubmit = async () => {
    const { stageId } = this.props;
    const incomeSchedules = withoutEmptyRow(this.state.incomeSchedules);
    let promises = [];
    this.setState({ handleSubmitting: true });
    try {
      notificationLoading({
        message: 'Сохранение данных...',
        key: 'saving'
      });
      this.validate(incomeSchedules);
      // сохраним график
      incomeSchedules.forEach((incomeSchedule) => {
        promises.push(
          this.saveUpdateIncomeSchedule({ ...incomeSchedule, stageId })
        );
      });
      const hasSaveError = await Promise.all(promises).then((incomeSchedules) => {
        return incomeSchedules.includes(undefined);
      });
      const hasDeleteError = await this.deleteIncomeSchedules();
      const hasError = hasSaveError || hasDeleteError;

      this.props.fetchIncomeSchedules();
      this.setState({
        touched: hasError,
        handleSubmitting: hasError
      });
      if (hasError) {
        notification.error({
          message: 'Ошибка',
          description: 'Не удалось сохранить все этапы'
        });
      }
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
    } finally {
      notification.destroy('saving');
    }
  };

  validateRequired(field, index) {
    const { handleSubmitting, submitting, incomeSchedules } = this.state;
    if (!submitting && handleSubmitting && !isEmpty(incomeSchedules[index])) {
      return isEmpty(incomeSchedules[index][field]) ? 'error' : 'validating';
    }
    return 'validating';
  }

  columns = [
  {
    title: 'Мнемокод',
    key: 'mnemocode',
    dataIndex: 'mnemocode',
    render: (mnemocode) => {
      const { readOnly } = this.props;
      return readOnly ? mnemocode : <Input disabled value={mnemocode} />;
    }
  },
  {
    title: 'Наименование номенклатуры',
    style: {
      overflow: 'hidden'
    },
    key: 'nomenclatureName',
    dataIndex: 'nomenclatureName',
    render: (nomenclatureName, offer, index) => {
      const { readOnly } = this.props;
      return readOnly ?
      nomenclatureType[nomenclatureName] :

      <StyledFormItem
        validateStatus={this.validateRequired('nomenclatureName', index)}>

            <NomenclatureTypeSelect
          placeholder="Номенклатура"
          onChange={(type) => {
            this.onChange(index, 'nomenclatureName', type);
          }}
          value={nomenclatureName} />

          </StyledFormItem>;

    }
  },
  {
    title: 'Количество',
    key: 'count',
    dataIndex: 'count',
    render: (count, offer, index) => {
      const { readOnly } = this.props;
      return readOnly ?
      count :

      <StyledFormItem
        validateStatus={this.validateRequired('count', index)}>

            <InputNumber
          style={{ width: '100%' }}
          placeholder="Количество"
          onChange={(count) => {
            this.onChange(index, 'count', count);
          }}
          value={count} />

          </StyledFormItem>;

    }
  },
  {
    title: 'Ед. измерения',
    key: 'measureType',
    dataIndex: 'measureType',
    render: (type, offer, index) => {
      const { readOnly } = this.props;
      return readOnly ?
      measureType[type] :

      <StyledFormItem
        validateStatus={this.validateRequired('measureType', index)}>

            <MeasureTypeSelect
          value={type}
          onChange={(type) => this.onChange(index, 'measureType', type)} />

          </StyledFormItem>;

    }
  },
  {
    title: 'Сумма руб. (без НДС)',
    key: 'sum',
    dataIndex: 'sum',
    render: (sum, incomeSchedule, index) => {
      const { readOnly } = this.props;
      return readOnly ?
      sum :

      <StyledFormItem validateStatus={this.validateRequired('sum', index)}>
            <InputNumber
          style={{ width: '100%' }}
          placeholder="Цена"
          onChange={(value) => this.onChange(index, 'sum', value)}
          value={sum} />

          </StyledFormItem>;

    }
  },
  {
    title: 'Сумма руб. (c НДС)',
    key: 'sumWithTax',
    dataIndex: 'sumWithTax',
    render: (
    sumWithTax,
    incomeSchedule,
    index) =>
    {
      const { readOnly } = this.props;
      return readOnly ?
      sumWithTax :

      <StyledFormItem
        validateStatus={this.validateRequired('sumWithTax', index)}>

            <InputNumber
          style={{ width: '100%' }}
          placeholder="Цена"
          onChange={(value) => this.onChange(index, 'sumWithTax', value)}
          value={sumWithTax} />

          </StyledFormItem>;

    }
  },
  {
    title: 'Дата начала',
    key: 'startDate',
    dataIndex: 'startDate',
    render: (
    startDate,
    incomeSchedule,
    index) =>
    {
      const { readOnly } = this.props;
      return readOnly ?
      formatDate(startDate) :

      <StyledFormItem
        validateStatus={this.validateRequired('startDate', index)}>

            <DatePicker
          placeholder="Дата"
          format="DD.MM.YYYY"
          value={startDate ? moment(startDate) : startDate}
          onChange={async (value) => {
            await this.onChange(
              index,
              'startDate',
              moment.
              utc(value).
              startOf('day').
              toISOString()
            );
            this.onChange(index, 'endDate', undefined);
          }} />

          </StyledFormItem>;

    }
  },
  {
    title: 'Дата окончания',
    key: 'endDate',
    dataIndex: 'endDate',
    render: (
    endDate,
    incomeSchedule,
    index) =>
    {
      const { readOnly } = this.props;
      return readOnly ?
      formatDate(endDate) :

      <StyledFormItem
        validateStatus={this.validateRequired('endDate', index)}>

            <DatePicker
          placeholder="Дата"
          format="DD.MM.YYYY"
          disabled={incomeSchedule.startDate ? false : true}
          disabledDate={(date) =>
          incomeSchedule.startDate ?
          moment.
          utc(date).
          startOf('day').
          isSameOrBefore(moment.utc(incomeSchedule.startDate)) :
          false
          }
          value={endDate ? moment(endDate) : endDate}
          onChange={(value) =>
          this.onChange(
            index,
            'endDate',
            moment.
            utc(value).
            startOf('day').
            toISOString()
          )
          } />

          </StyledFormItem>;

    }
  },
  {
    title: 'Точка графика',
    key: 'schedulePoint',
    dataIndex: 'schedulePoint',
    render: (
    schedulePoint,
    incomeSchedule,
    index) =>
    {
      const { readOnly } = this.props;
      return readOnly ?
      schedulePoint :

      <StyledFormItem
        validateStatus={this.validateRequired('schedulePoint', index)}>

            <Input
          value={schedulePoint}
          onChange={(e) =>
          this.onChange(index, 'schedulePoint', e.target.value)
          } />

          </StyledFormItem>;

    }
  },
  {
    width: '20px',
    renderRecord: (incomeSchedule, index) => {
      const { readOnly } = this.props;
      return readOnly ? null : !isEmpty(incomeSchedule) ?
      <Operations key={incomeSchedule.id}>
            <Dropdown
          overlayStyle={{ zIndex: '999' }}
          overlay={
          <Menu>
                  <Menu.Item onClick={() => this.onDelete(index)}>
                    Удалить
                  </Menu.Item>
                </Menu>
          }>

              <EllipsisOutlined
            style={{ fontSize: 16, color: '#2770FF' }} />

            </Dropdown>
          </Operations> :
      null;
    }
  }];


  render() {
    const { readOnly } = this.props;
    const { incomeSchedules, touched } = this.state;
    const data = readOnly ?
    withoutEmptyRow(incomeSchedules) :
    withEmptyRow(incomeSchedules);
    return (
      <>
        <ListTable columns={this.columns} data={data} />
        {touched &&
        <Footer>
            <Button onClick={this.handleSubmit} type="primary">
              Сохранить
            </Button>
            <Button onClick={this.handleCancel}>Отменить</Button>
          </Footer>
        }
      </>);

  }
}
